<template>
  <div class="l-container">
    <div class="p-mypage__resume__section">
      <div class="p-mypage__resume__h1">WEB履歴書</div>
      <a
        href="/mypage/resume/preview"
        target="_blank"
        class="c-button u-ml-auto -blue -no-shadow -slim u-w100 u-fs11 -ic -box-arrow-up-right u-dis-b"
        >プレビュー
      </a>
      <div class="p-mypage__resume__h2 u-mt12">WEB履歴書の完成度</div>
      <div class="p-mypage__resume__section__body -center">
        <ProgressCircle :progress="resume_info.total" />
        <div class="c-paper -border -text-center u-font-bold">
          WEB履歴書の完成度が100%に近づくと<br />エントリ通過率アップ!
        </div>
        <div
          v-if="resume_info.last_updated_at"
          class="u-mt10 p-mypage__resume__input_field__date u-ml-auto"
        >
          最終更新日時: {{ resume_info.last_updated_at }}
        </div>
      </div>
      <div v-if="resume_info.total < 90" class="u-mt8">
        <IconAlert type="error" icon>
          <template v-slot:title
            >WEB履歴書の完成度が90%未満の場合<br class="u-dis-sp-only" /><span
              class="u-dis-pc-only"
              >、</span
            >
            書類選考に進めない可能性があります！</template
          >
        </IconAlert>
      </div>
    </div>
    <div class="p-mypage__resume__section">
      <div class="p-mypage__resume__h3">WEB履歴書の入力項目</div>
      <Navitation :scores="resume_info" />
    </div>
    <div class="p-mypage__resume__section">
      <div class="p-mypage__resume__h3">履歴書・職務経歴書のダウンロード</div>
      <!-- 履歴書・職務経歴書ダウンロード/プレビューボタン -->
      <p class="u-fs11">・履歴書</p>
      <div
        class="u-flex -row -items-center u-gap7 u-mt10"
        style="justify-content: center"
      >
        <button
          class="c-button -simple-gray -with-following-icon -ic u-fs11 -slim u-p0"
          type="button"
          @click="downloadResume($event)"
        >
          <span>PDFダウンロード</span>
          <img
            src="../../../../images/icons/white-download.svg"
            class="u-mt2"
            style="width: 16px; height: 16px"
            alt="download"
          />
        </button>
        <button
          class="c-button -simple-gray -with-following-icon -ic u-fs11"
          type="button"
          @click="previewResume($event)"
        >
          <span>PDFプレビュー</span>
          <img
            src="../../../../images/icons/white-box-arrow-up-right.svg"
            style="width: 16px; height: 16px"
            alt="preview"
          />
        </button>
      </div>
      <div v-if="resume_info.past_careers_count > 0" class="u-mt12">
        <p class="u-fs11">・職務経歴書</p>
        <div
          class="u-flex -row -items-center u-gap7 u-mt10"
          style="justify-content: center"
        >
          <button
            class="c-button -simple-gray -with-following-icon -ic u-fs11 -slim u-p0"
            type="button"
            @click="downloadPastCareer($event)"
          >
            <span>PDFダウンロード</span>
            <img
              src="../../../../images/icons/white-download.svg"
              class="u-mt2"
              style="width: 16px; height: 16px"
              alt="download"
            />
          </button>
          <button
            class="c-button -simple-gray -with-following-icon -ic u-fs11 -slim"
            type="button"
            @click="previewPastCareer($event)"
          >
            <span>PDFプレビュー</span>
            <img
              src="../../../../images/icons/white-box-arrow-up-right.svg"
              style="width: 16px; height: 16px"
              alt="preview"
            />
          </button>
        </div>
      </div>
      <!-- /履歴書・職務経歴書ダウンロード/プレビューボタン -->
    </div>
    <div class="p-mypage__resume__section">
      <div class="p-mypage__resume__h3">履歴書・職務経歴書のアップロード</div>
      <div class="p-mypage__resume__section__body u-p10">
        <div class="p-mypage__resume__description">
          既に履歴書・職務経歴書をお持ちの場合はアップロードもできます。<br />
          WEB履歴書で入力されている方はアップロード不要です。
        </div>
        <a
          class="c-button -green -expanded -no-shadow -slim u-fs11 -ic -chevron-right"
          href="/mypage/resume/upload"
        >
          履歴書・職務経歴書のアップロードはこちら
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import ProgressCircle from '../progress_circle.vue';
import Navitation from './navigation.vue';
import IconAlert from '../icon_alert.vue';
import { pdfActionsMixin } from './pdfActionsMixin';
import * as toastr from 'toastr';
import axios from 'axios';

export default {
  mixins: [pdfActionsMixin],
  components: {
    ProgressCircle,
    Navitation,
    IconAlert,
  },
  data() {
    return {
      resume_info: {},
    };
  },
  beforeCreate() {
    axios
      .get('/api/mypage/resume_info')
      .then((response) => this.$set(this, 'resume_info', response.data));
  },
  mounted() {
    // クエリパラメータで「successed=true」があれば「更新されました」を表示
    const params = location.search;
    if (!params) return;
    const paramList = params.slice(1).split('&');
    const successed = paramList.includes('successed=true');
    if (successed) {
      toastr.success('更新されました。');
    }
  },
};
</script>
